<template>
  <QuestionBase :id="db.saveField"
                :question="question"
                :errors="[...jsErrors]"
                :valid="!!data.length">
    <div class="accordion sub-items">
      <div class="question-box with-arrow mt-32">
        <transition-group name="fade">
          <ObjectCard v-for="(item, index) in data"
                      :key="'beneficiaryAmendment-' + item.id"
                      :id="'beneficiaryAmendment' + index"
                      :ref="'beneficiaryAmendment' + index"
                      :value="item"
                      :index="index"
                      :title="itemTitle(item)"
                      type="beneficiaryAmendment"
                      :loading="false"
                      :show-save="true"
                      :show-confirm="true"
                      @delete="deleteItem(item.id)"
                      @save="saveItem(index)">
            <b-form-textarea v-model="item.description"
                          placeholder="Please provide details..."
                          class="mt-2"/>
          </ObjectCard>
        </transition-group>

        <!-- New item form -->
        <ObjectCard v-if="form" class="mt-4"
                    ref="beneficiary-add"
                    :value="form"
                    :title="typeLabel(form.type)"
                    type="beneficiaryAmendment-add"
                    :loading="false"
                    :show-save="false"
                    :show-confirm="true"
                    @delete="form = null"
                    @save="confirmAdd">
          <b-form-textarea v-model="form.description"
                          placeholder="Please provide details..."
                          class="mt-2"/>
        </ObjectCard>

        <b-button-group v-if="!form" class="w-100 mt-4">
          <b-button class="btn-question mr-1" @click="add('add')">
            <i class="i-Add text-25 font-weight-800 mr-2"></i> Add
          </b-button>
          <b-button class="btn-question mr-1" @click="add('remove')">
            <i class="i-Close text-25 font-weight-800 mr-2"></i> Remove
          </b-button>
          <b-button class="btn-question" @click="add('edit')">
            <i class="i-Pen-2 text-25 font-weight-800 mr-2"></i> Edit Details
          </b-button>
        </b-button-group>
      </div>
    </div>
  </QuestionBase>
</template>

<script>
import { questionLoadHelpers } from "@/components/common/questionnaires/question/helpers/questionLoadHelpers";
import {objectSaveHelpers} from "@/components/common/questionnaires/question/questions/objects/objectSaveHelpers";
import { saveHelpers } from "@/views/questionnaires/saveHelpers";

import QuestionBase from "@/components/common/questionnaires/question/QuestionBase";
import ObjectCard from "@/components/common/questionnaires/question/questions/objects/ObjectCard";

export default {
  name: 'Beneficiaries',
  mixins: [questionLoadHelpers, saveHelpers, objectSaveHelpers],
  components: {
    ObjectCard,
    QuestionBase
  },
  props: {
    value: {
      type: Array,
      required: false
    },
    saveLocation: {
      type: String,
      default: 'amendment_data'
    }
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input', value)
      },
      get() {
        return this.value || []
      }
    }
  },
  data() {
    return {
      question: {
        title: 'How would you like to update the beneficiaries listed in your Will?',
        subTitle: 'Use this section to add new beneficiaries, remove current ones, or update their personal details like a new surname or address. When adding someone new, be sure to provide their full legal name and their relationship to you so there is no ambiguity about their identity when it comes time to distribute your estate.',
        tip: null
      },
      db: {
        saveLocation: 'amendment_data',
        saveField: 'beneficiaries',
        formPath: 'beneficiaries',
        jsonSaveField: 'beneficiaries'
      },
      args: {
        skippable: false,
        required: true,
        customErrorMessage: 'Please add at least one change before continuing',
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
      form: null,
    }
  },
  methods: {
    typeLabel(type) {
      const labels = {
        add: 'Add Beneficiary',
        remove: 'Remove Beneficiary',
        edit: 'Edit Beneficiary Details'
      }
      return labels[type] || type
    },
    itemTitle(item) {
      const prefix = this.typeLabel(item.type)
      return item.description ? `${prefix}: ${item.description}` : prefix
    },
    add(type) {
      this.form = { type, description: '' }
    },
    confirmAdd() {
      if (!this.form) return
      const newItem = {
        id: Date.now(),
        type: this.form.type,
        description: this.form.description
      }
      this.$emit('input', [...this.data, newItem])
      this.form = null
      this.$nextTick(() => { this.save() })
    },
    deleteItem(id) {
      this.$emit('input', this.data.filter(item => item.id !== id))
      this.$nextTick(() => { this.save() })
    },
    saveItem(index) {
      this.$emit('input', [...this.data])
      this.$nextTick(() => {
        this.save()
        const card = this.$refs['beneficiaryAmendment' + index]
        if (card) card.showData = false
        this.closeCard ('beneficiaryAmendment' + index)
      })
    }
  }
}
</script>
